export default {
  message: {
    Tour: {
      continue: "Doorgaan",
      back: "Terug",
      finish: "Voltooien"
    },
    Login: {
      title: "Ouder aanmelden",
      sign_in: "Aanmelden",
      login_fail:
        "Authenticatie mislukt. Probeer het opnieuw of neem contact op met uw school voor hulp bij het aanmelden.",
      forgot_password: "Wachtwoord vergeten",
      create_account: "Account aanmaken",
      password: "Wachtwoord",
      confirm_password: "Bevestig wachtwoord",
      password_reminder: "Wachtwoordherinnering",
      enter_email: "Voer uw e-mailadres in",
      validation_error: "Validatiefout",
      password_reminder_error_no_user_register:
        "De gebruikersnaam die u heeft ingevoerd kon niet worden gevonden. Probeer het opnieuw of maak een nieuw account aan.",
      password_reminder_error_no_user: "De gebruikersnaam die u heeft ingevoerd kon niet worden gevonden.",
      password_reminder_sent: "Er is een e-mail met verdere instructies verzonden naar {email}.",
      password_reminder_sent_message:
        "Het kan enkele minuten duren voordat de e-mail arriveert. Controleer ook uw spammap.",
      password_trouble_email: "Als u nog steeds problemen ondervindt, neem dan contact op met {email}.",
      password_trouble_school:
        "Als u nog steeds problemen ondervindt, neem dan contact op met uw school voor hulp.",
      return_to_sign_in: "Terug naar aanmelden",
      create_my_account: "Mijn account aanmaken",
      or_sign_in_with: "OF MELD U AAN MET",
      password_reset: "Kies een nieuw wachtwoord voor uw account.",
      password_reset_warning:
        "Als u niet heeft gevraagd om uw wachtwoord te wijzigen, neem dan onmiddellijk contact op met uw schoolbeheerder.",
      password_update: "Nieuw wachtwoord kiezen",
      password_update_confirm: "Bevestig nieuw wachtwoord",
      password_update_success: "Uw nieuwe wachtwoord is opgeslagen."
    },
    AccountSettings: {
      title: "Accountinstellingen",
      first_name: "Voornaam",
      last_name: "Achternaam",
      email: "E-mail",
      username: "Gebruikersnaam",
      password: "Wachtwoord",
      students: "Leerlingen",
      teachers: "Docenten",
      external_id: "Externe ID",
      phone: "Telefoonnummer",
      phone_required: "Telefoonnummer is verplicht",
      edit: "Bewerken",
      remove: "Verwijderen",
      add: "Toevoegen",
      remove_message: "Weet u zeker dat u deze leerling wilt verwijderen?",
      yes: "Ja",
      no: "Nee",
      add_student: "Leerling toevoegen",
      close: "Sluiten",
      save: "Wijzigingen opslaan",
      cancel: "Annuleren",
      student_alert_message: "U moet minstens één leerling invoeren.",
      logout: "Afmelden"
    },
    TrialStatus: {
      title: "Update Trial Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      updatedSuccess: "Trial status updated successfully",
      updateError: "Failed to update trial status",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    LeadStatus: {
      title: "Update Lead Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      reject: "Reject",
      updatedSuccess: "Lead status updated successfully",
      updateError: "Failed to update lead status",
      convertedNote: "This marks the lead as a customer. If a school exists, it may be set to active.",
      suppressedNote: "This suppresses the lead. You can restore it later from Suppressed.",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    WelcomeEmail: {
      title: "Send welcome email?",
      schoolLabel: "School",
      districtLabel: "District",
      contactLabel: "Contact",
      emailLabel: "Email",
      subdomainLabel: "Subdomain",
      usernameLabel: "Username",
      body: "PTC Wizard will email this account's admin-site credentials and documentation links.",
      confirm: "Send email",
      cancel: "Cancel",
      success: "Welcome email sent",
      error: "Failed to send welcome email",
      tooltip: "Send welcome email"
    },
    Navbar: {
      my_meetings: "Mijn afspraken",
      language: "Nederlands",
      help: "Help",
      account_settings: "Accountinstellingen",
      user_management: "User Management",
      logout: "Afmelden"
    },
    SubNavbar: {
      meeting: "Afspraak",
      event: "Evenement",
      print: "Afdrukken",
      email: "E-mail",
      export: "Exporteren"
    },
    ConferenceCard: {
      add_edit_meetings: "Afspraken toevoegen/bewerken",
      opening: "Open",
      closed: "Gesloten"
    },
    Agenda: {
      full_agenda: "Volledige agenda",
      empty_state_title: "We konden geen conferenties voor u vinden.",
      empty_state_message: "Als u vragen heeft, neem dan contact op met uw schoolvertegenwoordiger.",
      confirmation_modal_title: "Agenda bevestigd",
      confirmation_modal_message:
        "Uw agenda is succesvol bevestigd en er is een e-mail naar u verzonden.",
      complete_button: "Klaar!"
    },
    AgendaCard: {
      room: "Kamer niet beschikbaar",
      room_with_value: "Kamer: {room}",
      virtual_meeting: "Virtuele vergadering",
      all_conferences: "Alle conferenties",
      conference: "Conferentie",
      student: "Leerling",
      meeting_with: "Afspraak met",
      date_time: "Datum/tijd",
      meeting_type: "Type afspraak",
      location: "Locatie",
      comment: "Opmerking",
      action: "Actie",
      delete: "Verwijderen",
      add_comment: "Opmerking toevoegen",
      join: "Deelnemen aan vergadering",
      choose_meeting_type: "Kies type afspraak",
      in_person: "Persoonlijk",
      phone: "Telefoon",
      callback: "Terugbellen",
      virtual: "Virtueel",
      hybrid: "Hybride",
      unavailable: "Niet beschikbaar",
      tooltip_translator:
        "Tolkservice is niet gegarandeerd, maar de school zal er alles aan doen om deze beschikbaar te maken.",
      translator_requested: "Tolk aangevraagd",
      clear_translator: "Tolkverzoek wissen",
      need_translator: "Heeft u een tolk nodig?",
      choose_language: "Kies een taal"
    },
    ScheduleMatrix: {
      no_teachers_title: "Geen docenten of teams geselecteerd.",
      no_teachers_message: "Kies een docent om de beschikbare tijden te bekijken.",
      choose_teachers_button: "Bekijk beschikbare docenten of teams",
      choose_student: "Voor welke leerling?",
      cancel: "Annuleren"
    },
    Matrix: {
      teachers: "Docenten",
      agenda: "Bekijken en doorgaan"
    },
    DrawerTeachers: {
      teachers: "Docenten",
      name: "Naam",
      description: "Beschrijving",
      student: "Leerling",
      teacher_team: "Docent/Team",
      show_more: "Meer docenten tonen",
      show_all: "Alle docenten van de school tonen",
      selected: "({count}) geselecteerd",
      closeDrawer: "Doorgaan naar planning",
      search: "Zoek een docent of team",
      not_available: "Deze docent heeft geen beschikbare afspraaktijden op {date}."
    },
    DrawerAgenda: {
      no_meetings_title: "U heeft geen geplande afspraken.",
      no_meetings_message: "Zodra u een docent en tijdslot heeft gekozen, verschijnt het hier.",
      new_meeting_label: "Nieuw",
      cancel_button: "Annuleren",
      student_label: "Leerling",
      meeting_type_location: "Type/locatie afspraak",
      comment_label: "Opmerking",
      save_comment_button: "Opmerking opslaan",
      confirm_label: "Bevestig alstublieft:",
      confirm_cancel_button: "Ja, annuleer mijn afspraak met ",
      do_not_cancel_button: "Niet annuleren",
      confirm_agenda_button: "Bevestig deze agenda",
      confirm_agenda_message_line1: "U kunt altijd terugkomen en wijzigingen aanbrengen.",
      confirm_agenda_message_line2: "Uw huidige agenda wordt naar u gemaild."
    },
    EmailConsent: {
      message:
        "Om uw privacy en veiligheid te beschermen, hebben we uw toestemming nodig om communicatie naar uw e-mailadres te sturen.",
      consent: "Toestemming geven"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site's account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    }
  }
};
